/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Company_TitleInputs */

const en_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company`)
};

const de_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen`)
};

const fr_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'entreprise`)
};

const es_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La empresa`)
};

const it_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'azienda`)
};

const nl_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bedrijf`)
};

const pl_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

const fi_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritys`)
};

const da_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virksomheden`)
};

const sv_about_company_title = /** @type {(inputs: About_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foretaget`)
};

/**
* | output |
* | --- |
* | "The Company" |
*
* @param {About_Company_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_company_title = /** @type {((inputs?: About_Company_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Company_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_company_title(inputs)
	if (locale === "fr") return fr_about_company_title(inputs)
	if (locale === "es") return es_about_company_title(inputs)
	if (locale === "it") return it_about_company_title(inputs)
	if (locale === "nl") return nl_about_company_title(inputs)
	if (locale === "pl") return pl_about_company_title(inputs)
	if (locale === "fi") return fi_about_company_title(inputs)
	if (locale === "da") return da_about_company_title(inputs)
	if (locale === "sv") return sv_about_company_title(inputs)
	return en_about_company_title(inputs)
});